const highRiskProcess = (processStats) => {
  return processStats?.departments?.reduce(
    (value, department) => value + department.risks?.high,
    0,
  )
}

export default highRiskProcess
